export default {"src":"/_next/static/media/search.c96dcf42.svg","height":48,"width":46,"blurWidth":0,"blurHeight":0};